import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

export function EmptyState({
  title,
  description,
  action,
  className,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "rounded-2xl border border-dashed border-line p-10 flex flex-col items-center text-center gap-3",
        className,
      )}
    >
      <h3 className="text-lg font-semibold text-ink tracking-tight">{title}</h3>
      {description ? <p className="text-sm text-ink-dim max-w-md">{description}</p> : null}
      {action}
    </div>
  );
}
